import useStoreHandler from '@frontend/jetlend-core/src/hooks/useStoreHandler';
import ContentTransitionWrapper from '@frontend/jetlend-web-ui/src/components/ContentTransitionWrapper/ContentTransitionWrapper';
import React from 'react';
import {
    BorrowerLimitPrescoringStatusType,
    BorrowerLimitPrescoringStoreData,
} from '@app/models/borrowers/limitPrescoring';
import { limitPrescoringStoreHandler } from '@app/ducks/borrowers/borrowers';
import ScoringLoader from '../ScoringLoader/ScoringLoader';
import ScoringSuccess from '../ScoringSuccess/ScoringSuccess';
import styles from './ScoringProcess.module.scss';

/**
 * Компонент с анимированным процессом скоринга
 */
export default function ScoringProcess() {
    const [ data ] = useStoreHandler<BorrowerLimitPrescoringStoreData>(limitPrescoringStoreHandler);

    const isLoading = data?.scoring_status === BorrowerLimitPrescoringStatusType.UPDATING;
    const decisionIsReady = (
        data?.scoring_status === BorrowerLimitPrescoringStatusType.APPROVE ||
            data?.scoring_status === BorrowerLimitPrescoringStatusType.REJECT
    );

    return (
        <>
            <ContentTransitionWrapper transitionKey={data.scoring_status}>
                {isLoading && (
                    <div className={styles['subtitle']}>Расчет лимита</div>
                )}
                {decisionIsReady && (
                    <div className={styles['subtitle']}>Условия рассчитаны</div>
                )}
            </ContentTransitionWrapper>
            <div className={styles['subtitle']}>
                Для просмотра условий подтвердите номер телефона
            </div>
            <ContentTransitionWrapper transitionKey={data.scoring_status}>
                {isLoading && (
                    <ScoringLoader />
                )}
                {decisionIsReady && (
                    <ScoringSuccess
                        hideContinueButton
                        masked
                    />
                )}
            </ContentTransitionWrapper>
        </>
    );
}